import { render } from "./VatSettings.vue?vue&type=template&id=e5310324&scoped=true"
import script from "./VatSettings.vue?vue&type=script&lang=js"
export * from "./VatSettings.vue?vue&type=script&lang=js"

import "./VatSettings.vue?vue&type=style&index=0&id=e5310324&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5310324"]])

export default __exports__